// SummaryCard.js
import { Grid, Typography } from "@mui/material";

const SummaryCard = ({ status, created, updated, protocolNumber }) => {
  return (
    <Grid sx={{ padding: 4 }} container className="card">
      <Grid align="center" item xs={12}>
        <strong>ΑΙΤΗΣΗ ΜΕΤΑΚΙΝΗΣΗΣ</strong>
      </Grid>
      <br />
      <br />
      <Grid container item xs={12} md={6}>
        <Grid item xs={6} mb={1}>
          <Typography fontWeight="bold">Κατάσταση:</Typography>
        </Grid>
        <Grid item xs={6} mb={1}>
          <Typography>{status?.name}</Typography>
        </Grid>
      </Grid>
      <Grid container item xs={12} md={6}>
        <Grid item xs={6} mb={1}>
          <Typography fontWeight="bold">Α/Α Αίτησης:</Typography>
        </Grid>
        <Grid item xs={6} mb={1}>
          <Typography>{protocolNumber}</Typography>
        </Grid>
      </Grid>
      <Grid container item xs={12} md={6}>
        <Grid item xs={6} mb={1}>
          <Typography fontWeight="bold">Ημ. Δημιουργίας:</Typography>
        </Grid>
        <Grid item xs={6} mb={1}>
          <Typography>{created?.dateFormatted}</Typography>
        </Grid>
      </Grid>
      <Grid container item xs={12} md={6}>
        <Grid item xs={6} mb={1}>
          <Typography fontWeight="bold">Ημ. Τελευταίας Ενημέρωσης:</Typography>
        </Grid>
        <Grid item xs={6} mb={1}>
          <Typography>{updated?.dateFormatted}</Typography>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default SummaryCard;
